import { BulkCreateForAssembliesInput, RiskFieldsTypeEnum } from '@/__generated__/graphql';
import { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai';
import { cofCommentsState, pofCommentsState, transitionCommentsState } from '../state/atoms';

export const useCommentsState = (type: string) => {
  const [pofComments, setPoFComments] = useAtom(pofCommentsState);
  const [cofComments, setCoFComments] = useAtom(cofCommentsState);
  const [transitionComments, setTransitionComments] = useAtom(transitionCommentsState);

  const commentState = useMemo(() => {
    return type === RiskFieldsTypeEnum.Pof.toString()
      ? pofComments
      : type === RiskFieldsTypeEnum.Cof.toString()
        ? cofComments
        : transitionComments;
  }, [cofComments, pofComments, transitionComments, type]);

  const setCommentsState = useCallback(
    (
      newValueOrUpdater:
        | BulkCreateForAssembliesInput
        | null
        | undefined
        | ((
            previous: BulkCreateForAssembliesInput | null | undefined
          ) => BulkCreateForAssembliesInput | null | undefined)
    ) => {
      if (type === RiskFieldsTypeEnum.Pof.toString()) {
        setPoFComments(newValueOrUpdater);
      } else if (type === RiskFieldsTypeEnum.Cof.toString()) {
        setCoFComments(newValueOrUpdater);
      } else {
        setTransitionComments(newValueOrUpdater);
      }
    },
    [setCoFComments, setPoFComments, setTransitionComments, type]
  );

  return { commentState, setCommentsState };
};
